import { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { getRoutesConfig } from "../routes/ProjectRoutes";
import { NavMenu, ProjectsDropdown } from "../components";
import { IonRow, IonCol } from "@ionic/react";
import { getProjectOptions } from "../helpers/helpers";

export const NavHeader = (props) => {
  const { isMobile, isIntroPage, project, title, fontClass } = props;

  const projectOptions = useMemo(() => getProjectOptions(), []);
  const routesConfig = getRoutesConfig(project);
  const navItems = routesConfig?.filter((item) => item?.label);

  if (isIntroPage) {
    return null;
  }

  return (
    <div id="Header" className="header shadow-img ">
      {isMobile ? (
        <CompactHeader
          project={project}
          projectOptions={projectOptions}
          navItems={navItems}
          title={title}
          fontClass={fontClass}
        />
      ) : (
        <CompleteHeader
          projectOptions={projectOptions}
          navItems={navItems}
          project={project}
          title={title}
          fontClass={fontClass}
        />
      )}
    </div>
  );
};

const CompactHeader = (props) => {
  const { projectOptions, navItems, title, fontClass, project } = props;

  return (
    <IonRow className="flex-center">
      <IonCol size="8" className="title-col-compact">
        <NavLink to="/" className={`title-text ${fontClass}`}>
          {title}
        </NavLink>
      </IonCol>
      <NavMenu
        projectOptions={projectOptions}
        navItems={navItems}
        project={project}
      />
    </IonRow>
  );
};

const CompleteHeader = (props) => {
  const { project, projectOptions, navItems, title, fontClass } = props;

  return (
    <div>
      <IonRow className="nav-items-container">
        <ProjectsDropdown projectOptions={projectOptions} />
        <IonCol className="nav-items-col">
          <ul>
            {navItems.map((item, index) => (
              <NavLink
                key={index}
                className="nav-item"
                to={item?.path}
                end={item?.path === `/${project}`}
                style={({ isActive }) => ({
                  color: isActive ? "#3ad246" : null,
                })}
              >
                <span>{item?.label}</span>
              </NavLink>
            ))}
          </ul>
        </IonCol>
        <IonCol className="shop-nav-item"></IonCol>
      </IonRow>
      <div className="title-container">
        <NavLink to="/" className={`title-text ${fontClass}`}>
          {title}
        </NavLink>
      </div>
    </div>
  );
};
